
const AddCaseModal = ({ handleClickAddCaseModal }) => {
  return (
    <section onClick={handleClickAddCaseModal} className="addcase_modal">
      <span>Προσθήκη Υπόθεσης</span>
    </section>
  )
}

export default AddCaseModal